import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store'

Vue.use(Router)

const Home = () => import('@/pages/home/home.vue')
const MatchDetail = () => import('@/pages/matchDetail/matchDetail.vue')
const FindDetail = () => import('@/pages/findDetail/findDetail.vue')
const Equip = () => import('@/pages/equip/equip.vue')
const EquipList = () => import('@/pages/equipList/equipList.vue')
const EquipDetail = () => import('@/pages/equipDetail/equipDetail.vue')
const Collect = () => import('@/pages/collect/collect.vue')
const CollectText = () => import('@/pages/collectText/collectText.vue')
const SignUp = () => import('@/pages/signUp/signUp.vue')
const AddSignup = () => import('@/pages/addSignup/addSignup.vue')
const SignupList = () => import('@/pages/signupList/signupList.vue')
const Pay = () => import('@/pages/pay/pay.vue')
// const News = () => import('@/pages/news/news.vue')
// const Detail = () => import('@/pages/detail/detail.vue')
const Login = () => import('@/pages/login/login.vue')
const Forgot = () => import('@/pages/forgot/forgot.vue')
// const LoginNext = () => import('@/pages/loginNext/loginNext.vue')
const SetPwd = () => import('@/pages/setPwd/setPwd.vue')
const Deal = () => import('@/pages/deal/deal.vue')
const Register = () => import('@/pages/register/register.vue')

const Match = () => import('@/pages/match/Match.vue')


// const Analysis = () => import('@/pages/analysis/analysis.vue')
// const Score = () => import('@/pages/score/score.vue')
const Personal = () => import('@/pages/personal/personal.vue')
const PersonalSetup = () => import('@/pages/personalSetup/personalSetup.vue')
const Release = () => import('@/pages/release/release.vue')
const Account = () => import('@/pages/account/account.vue')
const NoteList = () => import('@/pages/noteList/noteList.vue')
const ModifyTel = () => import('@/pages/modifyTel/modifyTel.vue')
const ModifyPwd = () => import('@/pages/modifyPwd/modifyPwd.vue')
const ModifyInfo = () => import('@/pages/modifyInfo/modifyInfo.vue')

const Funs = () => import('@/pages/funs/index.vue')
const Follow = () => import('@/pages/follow/index.vue')
const User = () => import('@/pages/user/index.vue')





const router = new Router({
  // routes配置最好加上name属性，用于参数传递
  routes: [
   {
      path: '',
      redirect: '/home'
    },
    {
      path: '/home',
      name:'home',
      component: Home
    },
    {
      path: '/match',
      name:'match',
      component: Match
    },
    {
      path: '/matchDetail',
      component: MatchDetail
    },
    {
      path: '/findDetail',
      component: FindDetail
    },
    {
      path: '/equip',
      component: Equip
    },
    {
      path: '/equipList',
      component: EquipList
    },
    {
      path: '/equipDetail',
      component: EquipDetail
    },
    {
      path: '/collect',
      component: Collect
    },
    {
      path: '/collectText',
      component: CollectText
    },
    {
      path: '/signUp',
      component: SignUp
    },
    {
      path: '/addSignup',
      name: 'addSignup',
      component: AddSignup
    },
    {
      path: '/signupList',
      component: SignupList
    },
    {
      path: '/pay',
      component: Pay
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/forgot',
      component: Forgot
    },
    {
      path: '/register',
      component: Register
    },
    // {
    //   path: '/loginNext',
    //   component: LoginNext
    // },
    {
      path: '/setPwd',
      component: SetPwd
    },
    {
      path: '/deal',
      component: Deal
    },
    // {
    //   path: '/quiz',
    //   component: Quiz
    // },

    // {
    //   path: '/analysis',
    //   component: Analysis
    // },
    // {
    //   path: '/score',
    //   component: Score
    // },
    {
      path: '/personal',
      component: Personal
    },
    {
      path: '/personalSetup',
      component: PersonalSetup
    },
    {
      path: '/release',
      component: Release
    },
    {
      path: '/account',
      component: Account
    },
    {
      path: '/noteList',
      component: NoteList
    },
    {
      path: '/modifyTel',
      component: ModifyTel
    },
    {
      path: '/modifyPwd',
      component: ModifyPwd
    },
    {
      path: '/modifyInfo',
      component: ModifyInfo
    },
    {
      path: '/funs',
      name: 'Funs',
      component: Funs
    },
    {
      path: '/follows',
      name: 'Follow',
      component: Follow
    },
    {
      path: '/user/:id',
      name: 'User',
      component: User
    },
    // {
    //   path: '/detail',
    //   component: Detail
    // },

    // 设置404错误页面
    // {
    //    path:'*',
    //    component:Error
    // }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})


//白名单
let whiteList = ['/home', '/equip', '/login', '/deal', '/forgot', '/collectText', '/register', '/setPwd']
// 路由拦截
router.beforeEach((to, from, next) => {
  // 没有匹配成功的路由，跳转到index页面,to.matched.length一级路由返回1，二级路由返回2，以此类推
  // if (to.matched.length >= 1) {
  //   next()
  // } else {
  //   next({path: '/news'})
  // }

  if(!store.state.token && localStorage.getItem('token')){
      store.commit('SETTOKEN', localStorage.getItem('token'))
      store.commit('SETUSERINFO', JSON.parse(localStorage.getItem('userinfo')))
  }

  if(store.state.token || whiteList.indexOf(to.path) > -1){
    next()
  }else{
    next({path: '/login'})
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js